import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AbstractDialogComponent, Product } from '@motivforce/mx-library-angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-product-dialog',
  templateUrl: './add-product-dialog.component.html',
  styleUrls: ['./add-product-dialog.component.scss'],
})
export class AddProductDialogComponent extends AbstractDialogComponent implements OnInit {
  product: Product;
  mode: 'cart' | 'wishlist' = 'cart';

  constructor(public activeModal: NgbActiveModal, private router: Router) {
    super();
  }

  ngOnInit(): void {
    if (this.inputs && this.inputs.length > 0) {
      this.product = this.inputs[0];
      this.mode = this.inputs[1];
    }
  }

  onConfirm(): void {
    if (this.mode === 'cart') {
      this.router.navigateByUrl('/rewards-catalogue/cart');
    } else {
      this.router.navigateByUrl('/rewards-catalogue/wishlist');
    }
    this.activeModal.close();
  }
}
